function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#241F21;}\r\n\t.st1{fill:#231F20;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M9,3.5v5C9,8.776,8.776,9,8.5,9h-5C3.298,9,3.115,8.878,3.038,8.691S3.004,8.29,3.146,8.146L5.293,6 L1.146,1.854c-0.195-0.195-0.195-0.512,0-0.707s0.512-0.195,0.707,0L6,5.293l2.147-2.147C8.289,3.003,8.506,2.96,8.691,3.038 C8.878,3.115,9,3.298,9,3.5z M8.5,11h-5c-0.202,0-0.385,0.122-0.462,0.309s-0.034,0.402,0.108,0.545L5.293,14l-4.146,4.147 c-0.195,0.195-0.195,0.512,0,0.707C1.244,18.951,1.372,19,1.5,19s0.256-0.049,0.354-0.146L6,14.707l2.147,2.147 C8.242,16.949,8.37,17,8.5,17c0.064,0,0.13-0.012,0.191-0.038C8.878,16.885,9,16.702,9,16.5v-5C9,11.224,8.776,11,8.5,11z  M18.854,1.146c-0.195-0.195-0.512-0.195-0.707,0L14,5.293l-2.147-2.147c-0.143-0.143-0.359-0.186-0.545-0.108 C11.122,3.115,11,3.298,11,3.5v5C11,8.776,11.224,9,11.5,9h5c0.202,0,0.385-0.122,0.462-0.309s0.034-0.402-0.108-0.545L14.707,6 l4.146-4.147C19.049,1.658,19.049,1.342,18.854,1.146z M18.854,18.146L14.707,14l2.146-2.146c0.143-0.143,0.186-0.358,0.108-0.545 S16.702,11,16.5,11h-5c-0.276,0-0.5,0.224-0.5,0.5v5c0,0.202,0.122,0.385,0.309,0.462C11.37,16.988,11.436,17,11.5,17 c0.13,0,0.258-0.051,0.354-0.146L14,14.707l4.146,4.147C18.244,18.951,18.372,19,18.5,19s0.256-0.049,0.354-0.146 C19.049,18.658,19.049,18.342,18.854,18.146z"
});

function SvgMinimizeScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimizeScreen);
export default __webpack_public_path__ + "static/media/minimize_screen.fcee4c97.svg";
export { ForwardRef as ReactComponent };